import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PlayerService } from '../player/player.service';
import { environment } from '../../../../environments/environment';
import { Balance } from '../../modules/cashier/balance';
import { PaymentSystems } from '../../modules/cashier/paymentSystems';
import { DepositResponse } from '../../modules/cashier/depositResponse';
import { Store } from '@ngrx/store';
import { AppState } from '../../appstates/appState';
import { CashierGetOpenWithDrawRequest, CashierGetBalanceStart, CashierGetBankAccount, PlayerSessionExpired } from '../../appstates/cashierstates/cashierActions';
import { LoginService } from '../login/login.service';
import { BankAccountInfo } from '../../modules/cashier/bankAccountInfo';
import { DepositSystems } from '../../modules/cashier/depositSystems';
import { WithdrawSystems } from '../../modules/cashier/withDraw';
import { TrasactionHistory } from '../../modules/cashier/trasactionhistory';

@Injectable({
  providedIn: 'root'
})
export class CashierService {

  constructor(private httpClient: HttpClient,
    private playerservice: PlayerService,
    private loginservice: LoginService,
    private store: Store<AppState>) { }

  onCashierGetBalance() {
    return this.httpClient.post<Balance>(`${environment.api.baseUrl}${environment.api.cashier.balance}`, {}, this.playerservice.httpOptions());
  }

  onCashierResetPlayMoney() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.cashier.resetPlayMoneyBalance}`, {}, this.playerservice.httpOptions());
  }
  sessionExpire(value: boolean) {
    if (value === true) {
      this.store.dispatch(new PlayerSessionExpired({ session: value }));
    }

  }
  onCashierGetPaymentSystems() {
    return this.httpClient.post<PaymentSystems>(`${environment.api.baseUrl}${environment.api.cashier.getPaymentSystems}`, {}, this.playerservice.httpOptions());
  }

  onCashierGetDepositSystems(pgid: any) {
    return this.httpClient.post<DepositSystems>(`${environment.api.baseUrl}${environment.api.cashier.depositSystems}` + '?pgid=' + pgid.id, {}, this.playerservice.httpOptions());
  }
  onCashierGetWithdrawSystems(pgid: any) {
    return this.httpClient.post<WithdrawSystems>(`${environment.api.baseUrl}${environment.api.cashier.withdrawSystems}` + '?pgid=' + pgid.id, {}, this.playerservice.httpOptions());
  }
  onCashierWithdrawCashout(postData: Object) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.cashier.withDrawCashout}`, postData, this.playerservice.httpOptions());
  }

  onCashierDeposit(postData: object) {
    return this.httpClient.post<DepositResponse>(`${environment.api.baseUrl}${environment.api.cashier.deposit}`, postData, this.playerservice.httpOptions());
  }

  // onCashierGetOpenWithdrawRequest() {
  //   return this.httpClient.post<WithDrawResponse>(`${environment.api.baseUrl}${environment.api.cashier.getOpenWithdrawRequests}`, {}, this.playerservice.httpOptions());
  // }

  onCashierCancelWithdrawRequest(postData: Object) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.cashier.cancelWithdrawRequest}`, postData, this.playerservice.httpOptions());
  }

  onCashierWithdrawRequest(postData: Object) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.cashier.withdraw}`, postData, this.playerservice.httpOptions());
  }
  onCashierTransactionHistory(postData: Object) {
    return this.httpClient.post<TrasactionHistory>(`${environment.api.baseUrl}${environment.api.history.transaction}`, postData, this.playerservice.httpOptions());
  }
  onCashierAddBankAccount(postData: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.cashier.addBankAccount}`, postData, this.playerservice.httpOptions());
  }

  onCashierGetBankAccount() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.cashier.getBankAccounts}`, {}, this.playerservice.httpOptions());
  }

  onCashierDeleteBankAccount(postData: Object) {
    return this.httpClient.post<BankAccountInfo>(`${environment.api.baseUrl}${environment.api.cashier.deleteBankAccounts}`, postData, this.playerservice.httpOptions());
  }
  onGetExchangeRatesRes(postData: Object) {
    return this.httpClient.post<BankAccountInfo>(`${environment.api.baseUrl}${environment.api.cashier.exchangRates}`, postData, this.playerservice.httpOptions());
  }

  onGetPlayerWageringInfo() {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.cashier.wageringInfo}`, {}, this.playerservice.httpOptions());
  }

  onCashierCancelWitdrawSuccess() {
    this.store.dispatch(new CashierGetOpenWithDrawRequest());
    this.store.dispatch(new CashierGetBalanceStart());
  }

  getCashierBankAccounts() {
    this.store.dispatch(new CashierGetBankAccount());
  }

}
